export type IdentityChipTone = 'neutral' | 'teal' | 'blue' | 'amber';

const TONE_CLASSES: Record<IdentityChipTone, string> = {
    neutral: 'text-gray-600 bg-gray-100',
    teal: 'text-[#2C6F67] bg-[#CAF2ED]',
    blue: 'text-blue-700 bg-blue-50',
    amber: 'text-amber-700 bg-amber-50'
};

interface IdentityChipProps {
    children: string;
    tone?: IdentityChipTone;
}

// Small metadata tag (account type / network / version / ...) - shared by
// the practice detail header's identity row (PracticeDetailHeader) and the
// practices list row (PracticesTable) so both surfaces render the exact same
// treatment rather than two copies of the same class string drifting apart.
export function IdentityChip({ children, tone = 'neutral' }: IdentityChipProps) {
    return (
        <span
            className={`text-[11px] font-semibold rounded-full px-2 py-0.5 whitespace-nowrap ${TONE_CLASSES[tone]}`}
        >
            {children}
        </span>
    );
}
